<script setup>
defineProps({
    testimonial: Object
})
</script>

<script>
export default {
    data(){
        return {
        }
    },
    mounted(){

    }
}
</script>

<template>
    <li class="splide__slide">
        <div class="row">
            <div class="col-lg-3">
                <div class="testimoniols-img">
                    <figure class="mb-0">
                        <img :src="asset(testimonial.image)" onerror="this.src='/images/homepage/testimonial/testimonial.png'" alt="Testimonial" class="with-loading">
                    </figure>
                </div>
            </div>
            <div class="col-lg-9 mt-4 mt-lg-0">
                <div class="testimoniols-content">
                    <p>
                        {{ testimonial.message }}
                    </p>
                    <div class="author">
                        <span class="line"></span>
                        <h4 class="text-capitalize">{{ testimonial.name }}, {{ testimonial.company }}</h4>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>